import { Box, Container, Grid } from "@mui/material";
import { Fragment } from "react";
import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { getValidationSchema } from "../../../../shared/validations/schema";
import { useNavigate } from "react-router-dom";
import LoginPageCard from "../../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../../shared/components/auth/menuContainer";
import { styled } from "@mui/material/styles";
import LoginLine from "../../../../assets/img/login-line.svg";

const StyledMenuBg = styled(Box)(
  ({ theme }) => `
    top: 0;
    background: transparent;
    padding: 0 10%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
    color: rgba(15, 41, 85, 0.20);
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 275;
    line-height: normal;
    margin-top: 0;
    }.
     img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  `
);

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const { loading, modifyData } = useMutation(`/reset-password`);

  const textFields = [
    {
      id: "newPassword",
      name: "newPassword",
      label: "New Password",
      placeholder: "Enter your new password",
      required: true,
      type: "password",

    },
    {
      id: "confirmPassword",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm your new password",
      required: true,
      type: "password",
    },
  ];

  const resetPasswordForm = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validateOnBlur: true,
    validationSchema: getValidationSchema(["newPassword", "confirmPassword"]),
    onSubmit: async (formData: any) => {
      // Use the token directly from URL params (useParams)
      if (!token) {
        console.error("Token not found.");
      }

      const response = await modifyData(`/forgotResetPassword`, "post", {
        token: token, // Pass the token as part of the request
        newPassword: formData.newPassword,
      });

      if (response) {
        console.log("Password reset successful!");
        // Navigate to the login page
        navigate("/reset-success"); // Replace "/login" with your login route
      }
    },
  });

  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "end",
              padding: "24px",
              marginTop: "12%",
            }}
          >
            <Grid item md={4}>
              <MenuContainer />
              <StyledMenuBg>
                <h2>Reset Password</h2>
              </StyledMenuBg>
            </Grid>
            <Grid item md={0.75}>
              <img style={{ padding: "0 12px" }} src={LoginLine} alt="Logo" />
            </Grid>
            <Grid item md={3.5}>
              <form
                onSubmit={resetPasswordForm.handleSubmit}
                autoComplete="off"
                className="resetPasswordForm"
              >
                {textFields.map((field: any, index: number) => (
                  <Fragment key={field.id}>
                    {(field?.formField === undefined ||
                      field.formField === true) && (
                      <Grid item md={12} sm={12} xs={24}>
                        <InputTextfield
                          form={resetPasswordForm}
                          fieldProps={field}
                          key={index}
                        />
                      </Grid>
                    )}
                  </Fragment>
                ))}
                <Grid
                  container
                  sx={{
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <Grid item md={3} sx={{ mt: 2 }}>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="small"
                    >
                      Submit
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ResetPassword;
